import { CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    Image,
    Input,
    Row,
    Select,
    Tabs,
} from "antd";
import { useState } from "react";
import MainLayout from "../../../components/mainLayout";
import "./index.scss";
import Upload from '../../../commons/Upload';
import { authApis } from "../../../services/authApi";
import { nofication } from '../../../commons/Nofication';
import { useParams } from 'react-router-dom';
import { ROOT_URL } from "../../../constants/api";
import BackButton from "../../../commons/BackButton";

const Register = () => {
    const [fileList, setFileList] = useState();
    const [imageUrl, setImageUrl] = useState();
    const [data, setData] = useState();
    const [form] = Form.useForm();
    let { id } = useParams();

    useState(() => {
        if (id) {
            authApis
                .getDetailContact(id)
                .then((data) => {
                    if (data.status_code === 200) {
                        form.setFieldsValue(data.data);
                        setData(data.data);
                    } else {
                        nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                    }
                })
                .catch((errors) => {
                    nofication('error', 'Thất bại', 'Không kết nối được server');
                    console.log(errors);
                });
        }
    });

    const onFinish = async () => {
        const values = form.getFieldValue();
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            formData.append(key, values[key]);
        }
        id && formData.append('id', id);
        formData.append('logo', fileList);
        formData.append('imageUrl', imageUrl);
        await authApis
            .brand(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors);
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Partners"
            link="/brand/"
            titleNew="New Order / Edit"
        >
            <Form form={form} layout="vertical" onFinish={onFinish} colon={true} style={{ minHeight: 873 }}>
                <Row gutter={16}>
                    <Col span={24} style={{ paddingRight: "19px" }}>
                        <div className="box-class z">
                            <p><b>Họ tên:</b> {data?.name}</p>
                            <p><b>Email:</b> {data?.email}</p>
                            <p><b>Phone:</b> {data?.phone}</p>
                            <p><b>Message:</b> {data?.content}</p>
                            <Form.Item>
                                <Row
                                    justify="end"
                                    style={{ marginTop: 30 }}
                                >
                                    {/* <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col> */}
                                    <Col>
                                        <BackButton />
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
